'use strict';

/**
 * SliderButton
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.SliderButton = T.createModule({

	_eventNames: {
		button: 'slide-button',
		interval: 'slide-interval'
	},

	start: function start(resolve) {
		var _this = this;

		this.$ctx = $(this._ctx);

		this.index = this.$ctx.data('index');

		this._events.on(this._eventNames.interval, function (index) {
			_this.adaptState(index);
		});

		this.$ctx.click(function () {
			// To stage
			_this._events.emit(_this._eventNames.button, _this.index);
			// To other slider-buttons
			_this._events.emit(_this._eventNames.interval, _this.index);
		});

		resolve();
	},
	adaptState: function adaptState(index) {
		if (index === this.index) {
			this.$ctx.addClass('state-open');
		} else {
			this.$ctx.removeClass('state-open');
		}
	}
});